// Copyright (c) 2024, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { lazy } from "react";

const JobDescription = lazy(() => import("./jobDescription/JobDescription"));
const JobRequisition = lazy(() => import("./jobRequisition/JobRequisition"));
const Vacancy = lazy(() => import("./vacancy/Vacancy"));
const Candidate = lazy(() => import("./candidate/Candidate"));
const ApplicantOverview = lazy(
  () => import("./applicantOverview/ApplicantOverview"),
);
const InterviewView = lazy(() => import("./interview/Interview"));
const OfferLetters = lazy(() => import("./offerLetter/OfferLetter"));
const ReferralVacancy = lazy(() => import("./referralVacancy/ReferralVacancy"));

export const View = {
  JobDescription,
  JobRequisition,
  Vacancy,
  Candidate,
  ApplicantOverview,
  InterviewView,
  OfferLetters,
  ReferralVacancy,
};
